export { default } from './MediaCarousel';
export type { CarouselMedia } from './MediaCarousel';
